import classNames from "classnames"

import { Color } from "../../../../constants/V2/color"
import { getBorderColorClass } from "../../../../utils/V2/color"
import Typography from "../../../elements/V2/Typography"

import React from "react"

type TabSelectorItemProps = {
  id?: string
  title: string
  isSelected: boolean
  textColor: Color
  unselectedBorderColor?: Color
  onClick: () => void
  variant?: "underline" | "pill"
}

export const TabSelectorItem = ({
  id,
  title,
  isSelected,
  textColor,
  unselectedBorderColor,
  onClick,
  variant,
}: TabSelectorItemProps) => {
  const unselectedBorderClass = unselectedBorderColor
    ? getBorderColorClass(unselectedBorderColor)
    : "border-transparent"

  return (
    <div className="relative">
      <Typography
        id={id}
        font="grotesk"
        weight="medium"
        color={textColor}
        size="body-md"
        text={title}
        leadingNone
        className={classNames("cursor-pointer whitespace-nowrap", {
          "rounded-32 border px-[14px] pb-[9px] pt-[11px]": variant === "pill",
          [getBorderColorClass(textColor)]: isSelected,
          "opacity-50": !isSelected && variant === "underline",
          "mt-24 hover:opacity-100": variant === "underline",
          [unselectedBorderClass]: !isSelected,
          "hover:border-gray": !isSelected && variant === "pill",
        })}
        onClick={onClick}
      />
      {variant === "underline" && (
        <div
          className={classNames(
            "mt-20 h-[2px] w-full bg-blue transition-opacity duration-200 sm:h-[3px]",
            isSelected ? "opacity-100 delay-100" : "opacity-0"
          )}
        />
      )}
    </div>
  )
}
